import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
const headerHeight = 40;

export const Container = styled.div`
  height: calc(100vh - ${headerHeight}px);
`;

export const Logo = styled.img`
  width: 24px;
  height: 24px;
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${colors.white};
  font-weight: 500;
  font-size: 18px;
  line-height: 13px;
  cursor: pointer;

  & + div {
    display: none !important;
  }
`;

export const Separator = styled.div`
  width: 1px;
  height: 24px;
  margin: 0 8px 0 6px;
  background-color: ${colors.white};
`;
